import React from 'react'
import { normalizeSubjectData } from '../../utilities'
import { ReviewSubjectBusiness } from './ReviewSubjectBusiness'
import { ReviewSubjectIndividual } from './ReviewSubjectIndividual'
import { subjectType } from '../../strings/types'
import { formatSubjects } from '../../utilities'

export const ReviewSubjects = ({ values, ...props }) => {
  // Use repeatable format pattern if values al an array of subject objects.
  const subjects =
    Array.isArray(values) && values.length > 0
      ? formatSubjects(values)
      : normalizeSubjectData(values, 9)
  const singleSubject = subjects.length == 1

  return subjects.map((subject, index) => {
    let editFieldName = `subject_type_${index}`
    if (values[`subject_type_${index}`] === undefined)
      editFieldName = `subjects.${index}.subject_type`
    const subjectProps = {
      ...subject,
      ...props,
      editFieldName
    }
    const isBusiness = subject.subject_type === subjectType.business
    return (
      <section key={editFieldName}>
        {singleSubject ? <h2>Subject</h2> : <h2>Subject {index + 1}</h2>}
        {isBusiness ? (
          <ReviewSubjectBusiness {...subjectProps} />
        ) : (
          <ReviewSubjectIndividual {...subjectProps} />
        )}
      </section>
    )
  })
}
